module.exports = __webpack_public_path__ + "img/C06TechMountedArcherChampion_ua.85fe7d2d.webp";